"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.titleAndTextType = exports.priceType = exports.imagePropType = exports.filteringOptionsType = exports.filterType = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var titleAndTextType = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  text: _propTypes["default"].string
});
exports.titleAndTextType = titleAndTextType;
var priceType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});
exports.priceType = priceType;
var filteringOptionsType = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: imagePropType,
  price: priceType,
  titleAndText: titleAndTextType,
  selected: _propTypes["default"].bool
});
exports.filteringOptionsType = filteringOptionsType;
var filterType = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  label: _propTypes["default"].string,
  filteringOptions: _propTypes["default"].arrayOf(filteringOptionsType)
});
exports.filterType = filterType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  label: _propTypes["default"].string,
  titleAndText: titleAndTextType,
  filter: filterType
});
var _default = PROP_TYPES;
exports["default"] = _default;